import { put, takeEvery, fork, all, call } from 'redux-saga/effects';
import { ProgramEnrollment } from 'types/Enrollment';
import enrollmentStatusActionsCreators from '../actions/enrollmentStatus/actions';
import { SagaType, SagaWatcherType, SagaWorkerType } from './types';
import {
  EnrollmentStatusActionType,
} from '../actions/enrollmentStatus/types/actions';
import buildMockEnrollmentStatus from '../mocks/enrollmentStatus/buildMockEnrollmentStatus.json';
import { Programs } from '../constants/programs';
import { ErrorTypes } from '../constants/errorTypes';

const {
  fetchEnrollmentStatusResolved,
  fetchEnrollmentStatusRejected
} = enrollmentStatusActionsCreators;

export const getMockedData = (id: string): ProgramEnrollment => ({ ...buildMockEnrollmentStatus, programId: id });

export function* enrollmentStatusWorker(): SagaWorkerType<ProgramEnrollment[]> {
  try {

    const delaroProgram = yield all(Object.values(Programs).map(programId => call(getMockedData, programId)))

    yield put(
      fetchEnrollmentStatusResolved(delaroProgram)
    );

  } catch (e) {
    const error = e as Error;
    yield put(fetchEnrollmentStatusRejected(error.message as ErrorTypes));
  }
}

export function* enrollmentStatusWatcher(): SagaWatcherType {
  yield takeEvery(EnrollmentStatusActionType.FetchEnrollmentStatus, enrollmentStatusWorker);
}

export default function* enrollmentSaga(): SagaType {
  yield fork(enrollmentStatusWatcher);
}
